import { faTrashCan } from '@fortawesome/pro-regular-svg-icons'

import { useMutationDeleteBooking } from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type ParameterID } from '@flecto/types'
import { Modal, useNotifications } from '@flecto/ui'

import { CardBookingQuickDetails } from '../../../bookings'

export type ModalBookingActionDeleteProps = {
  bookingId?: ParameterID
  onSuccess?: () => void
}

export function ModalBookingActionDelete({
  bookingId,
  onSuccess,
}: ModalBookingActionDeleteProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_actions' })
  const { t: tActions } = useTranslation('shared', { keyPrefix: 'actions' })

  const { showNotification } = useNotifications()

  const { mutateAsync: deleteBooking } = useMutationDeleteBooking()

  const handleSubmit = async () => {
    try {
      await deleteBooking({ bookingId })
      showNotification({
        type: 'success',
        message: t('notification_action_delete_success'),
      })
      onSuccess?.()
    } catch {
      showNotification({
        type: 'error',
        message: t('notification_action_delete_error'),
      })
    }
  }

  return (
    <Modal size='md'>
      <Modal.Close />
      <Modal.Icon icon={faTrashCan} color='red' withCircleBackground />
      <Modal.Title>{t('modal_action_delete_title')}</Modal.Title>
      <Modal.Content>
        <CardBookingQuickDetails bookingId={bookingId} />
      </Modal.Content>
      <Modal.Cancel />
      <Modal.Submit color='red' onClick={handleSubmit}>
        {tActions('delete')}
      </Modal.Submit>
    </Modal>
  )
}
